import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {FormControl} from "@angular/forms";

@Component({
    selector: "fhm-evidence-type-select-control",
    templateUrl: "./evidence-type-select-control.component.html",
    styleUrls: ["./evidence-type-select-control.component.scss"],
    standalone: false
})
export class EvidenceTypeSelectControlComponent implements OnChanges {
    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() disabled: boolean;
    public options: any[] = [
        {label: "Customer Communication", value: "customer_communication"},
        {label: "Other", value: "uncategorized_file"}];

    public selectedValue: any;

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
